module.exports = __webpack_public_path__ + "static/media/icon_closemenu.b0277b68.svg";